import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=0f7ae540&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=0f7ae540&scoped=true&lang=css&"
import style2 from "./Detail.vue?vue&type=style&index=2&id=0f7ae540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ae540",
  null
  
)

export default component.exports
import {QFooter} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QFooter})
